// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__3ZgbU","card":"Card_card__6G_gf","imgcard":"Card_imgcard__1SCDp"};